import React from 'react'
import "../Frontend/stack.css"
const BackendStack = () => {
  return (
    <div className='stack-card'>
        <h4>Backend</h4>
        <div className='stack-card-list'>
            <p>Firebase Auth</p>
            <p className='stack-border-color-firebase'>Firebase</p>
            <p className='stack-border-color-next-auth'>Next-Auth v5</p>
            <p className='stack-border-color-prisma'>Prisma</p>
        </div>
    </div>
  )
}

export default BackendStack